// extracted by mini-css-extract-plugin
export default {"containerr":"df19C","mobile":"_1cKMj","loader":"Z8Buv","button":"_1SlU1","loading":"_2DSEp","full":"_2wo3r","rounded":"TwXwl"};